import React, { Component, Fragment } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { Link, Switch, Route } from 'react-router-dom';
import classNames from 'classnames';
import Select from 'react-select';
import format from 'date-fns/format';

import Tippy from '../../../utils/Tippy';
import Icon, {
  UserIcon,
  ClipboardIcon,
  ChatIcon,
  QuoteIcon,
  ArchiveIcon,
  ThrashIcon,
  ThumbsUpIcon,
  ThumbsDownIcon,
} from '../../../utils/icons';

class ArchivedMessage extends Component {
  handleListClick = e => {
    e.preventDefault();
    // Check clicked element for an anchor with class 'smartti-header'
    if (
      e.target &&
      e.target.nodeName === 'A' &&
      e.target.classList.contains('smartti-header')
    ) {
      // Toggle visibility on sibling div
      e.preventDefault();
      !e.target.nextSibling.style.display ||
      e.target.nextSibling.style.display === 'none'
        ? (e.target.nextSibling.style.display = 'block')
        : (e.target.nextSibling.style.display = 'none');
    }
  };

  componentDidMount() {
    if (this.wrapper) {
      this.wrapper.addEventListener('click', this.handleListClick);
    }
  }

  componentWillUnmount() {
    if (this.wrapper) {
      this.wrapper.removeEventListener('click', this.handleListClick);
    }
  }

  render() {
    const { id, chatId, approved, text, sender, source, sent } = this.props;

    const messageClasses = classNames({
      'chat-message': true,
      [`chat-message-type-${source}`]: true,
      [`chat-message-type-${source}-approved`]: approved === true,
      [`chat-message-type-${source}-disapproved`]: approved === false,
    });

    let textElem;
    switch (source) {
      case 'bot':
        textElem = (
          <div
            className="chat-message-text"
            dangerouslySetInnerHTML={{
              __html: text,
            }}
            ref={el => {
              this.wrapper = el;
            }}
          />
        );
        break;

      default:
        textElem = <div className="chat-message-text">{text}</div>;
    }

    // Notifications
    if (source === 'notification') {
      return <div className={messageClasses}>textElem</div>;
    }

    return (
      <div className={messageClasses}>
        <div className="chat-message-user" />
        <div className="chat-message-content">
          <div className="chat-message-arrow" />
          {textElem}
          <div className="chat-message-time">{format(sent, 'HH:mm')}</div>
        </div>
      </div>
    );
  }
}

export default ArchivedMessage;

